import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import metaEn from './en/meta.json';
import headerEn from './en/header.json';
import heroEn from './en/hero.json';
import carParkEn from './en/carPark.json';
import aboutUsEn from './en/aboutUs.json';
import whyWeEn from './en/whyWe.json';
import perfectTransferEn from './en/perfectTransfer.json';
import howItWorksEn from './en/howItWorks.json';
import faqEn from './en/faq.json';
import formAndReviewsEn from './en/formAndReviews.json';
import footerEn from './en/footer.json';
import leadFormEn from './en/leadForm.json';
import orderFormEn from './en/orderForm.json';

import metaUk from './uk/meta.json';
import headerUk from './uk/header.json';
import heroUk from './uk/hero.json';
import carParkUk from './uk/carPark.json';
import aboutUsUk from './uk/aboutUs.json';
import whyWeUk from './uk/whyWe.json';
import perfectTransferUk from './uk/perfectTransfer.json';
import howItWorksUk from './uk/howItWorks.json';
import faqUk from './uk/faq.json';
import formAndReviewsUk from './uk/formAndReviews.json';
import footerUk from './uk/footer.json';
import leadFormUk from './uk/leadForm.json';
import orderFormUk from './uk/orderForm.json';

import metaFr from './fr/meta.json';
import headerFr from './fr/header.json';
import heroFr from './fr/hero.json';
import carParkFr from './fr/carPark.json';
import aboutUsFr from './fr/aboutUs.json';
import whyWeFr from './fr/whyWe.json';
import perfectTransferFr from './fr/perfectTransfer.json';
import howItWorksFr from './fr/howItWorks.json';
import faqFr from './fr/faq.json';
import formAndReviewsFr from './fr/formAndReviews.json';
import footerFr from './fr/footer.json';
import leadFormFr from './fr/leadForm.json';
import orderFormFr from './fr/orderForm.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      meta: metaEn,
      header: headerEn,
      hero: heroEn,
      carPark: carParkEn,
      aboutUs: aboutUsEn,
      whyWe: whyWeEn,
      perfectTransfer: perfectTransferEn,
      howItWorks: howItWorksEn,
      faq: faqEn,
      formAndReviews: formAndReviewsEn,
      footer: footerEn,
      leadForm: leadFormEn,
      orderForm: orderFormEn,
    },
    uk: {
      meta: metaUk,
      header: headerUk,
      hero: heroUk,
      carPark: carParkUk,
      aboutUs: aboutUsUk,
      whyWe: whyWeUk,
      perfectTransfer: perfectTransferUk,
      howItWorks: howItWorksUk,
      faq: faqUk,
      formAndReviews: formAndReviewsUk,
      footer: footerUk,
      leadForm: leadFormUk,
      orderForm: orderFormUk,
    },
    fr: {
      meta: metaFr,
      header: headerFr,
      hero: heroFr,
      carPark: carParkFr,
      aboutUs: aboutUsFr,
      whyWe: whyWeFr,
      perfectTransfer: perfectTransferFr,
      howItWorks: howItWorksFr,
      faq: faqFr,
      formAndReviews: formAndReviewsFr,
      footer: footerFr,
      leadForm: leadFormFr,
      orderForm: orderFormFr,
    },
  },
  lng: 'uk',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
